module.exports = __webpack_public_path__ + "static/media/AleLincoln.7a83de00.JPG";